import { useState } from 'react';
import { UseFormRegisterReturn, FieldError } from 'react-hook-form';
import { ChevronDown } from 'lucide-react';

interface PapSelectProps {
  formBinding: UseFormRegisterReturn;
  options: any[];
  placeholder?: string;
  fieldName: string;
  optionLabel?: string;
  optionValue?: string;
  required?: boolean;
  fieldLabel: string;
  error?: FieldError;
}

const PapSelect: React.FC<PapSelectProps> = ({ formBinding, options, placeholder, fieldName, optionLabel = "name", optionValue = "id", required = false, fieldLabel, error }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="mb-5">
      <label className="form-label" htmlFor={fieldName}>
        {fieldLabel}{required && <span className="text-destructive ml-1">*</span>}
      </label>
      <div className={`relative rounded-xl transition-all duration-200 ${isFocused ? 'ring-2 ring-accent/20' : ''}`}>
        <select {...formBinding}
          name={fieldName}
          id={fieldName}
          className={`form-input appearance-none pr-10 ${error ? 'border-destructive focus:border-destructive focus:ring-destructive/20' : ''}`}
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            formBinding.onBlur(e);
          }}
        >
          <option value="">{placeholder}</option>
          {options.map((option: any) => (
            <option key={option[optionValue]} value={option[optionValue]}>{option[optionLabel]}</option>
          ))}
        </select>
        <ChevronDown className="absolute right-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" />
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-destructive flex items-center gap-1">
          {error.message}
        </p>
      )}
    </div>
  );
};

export default PapSelect;
